import post from '@/api/core/http/post'
import { buildApiUrl } from '@/api/core/url'
import {
  ConvertAssetsPreviewResponse,
  convertAssetsPreviewResponseSchema,
  ConvertAssetsResponse,
  convertAssetsResponseSchema
} from './schema'
import { TypedMutationsOptions } from '@/api/core/mutation/options'
import {
  QueryFunctionContext,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import { ApiError } from '@/api/core/errors'
import { TypedQueryOptions } from '@/api/core/query/options'

const path = `/arcade/convert`

export const convertAssets = async ({
  asset_ids,
  code
}: {
  asset_ids: number[]
  code?: string
}): Promise<ConvertAssetsResponse> =>
  post<ConvertAssetsResponse>(
    buildApiUrl(path, {
      asset_ids: asset_ids.join(','),
      preview: false,
      code
    }),
    {},
    convertAssetsResponseSchema
  )

export const useConvertAssetsMutation = (
  mutationOptions?: TypedMutationsOptions<ConvertAssetsResponse>
) => {
  return useMutation<
    ConvertAssetsResponse,
    ApiError,
    { asset_ids: number[]; code?: string }
  >(params => convertAssets(params), mutationOptions)
}

export const convertAssetsPreview = async (
  asset_ids: number[],
  queryContext?: QueryFunctionContext
): Promise<ConvertAssetsPreviewResponse> =>
  post<ConvertAssetsPreviewResponse>(
    buildApiUrl(path, {
      asset_ids: asset_ids.join(','),
      preview: 'true'
    }),
    queryContext,
    convertAssetsPreviewResponseSchema
  )

export const convertPreviewQueryKey = (asset_ids: number[]) =>
  [path, 'assets', asset_ids.join(',')] as const

export const useConvertAssetsPreview = (
  asset_ids: number[],
  queryOptions?: TypedQueryOptions<ConvertAssetsPreviewResponse>
) => {
  return useQuery<ConvertAssetsPreviewResponse, ApiError>(
    convertPreviewQueryKey(asset_ids),
    queryContext => convertAssetsPreview(asset_ids, queryContext),
    queryOptions
  )
}
